import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import MovementType from "./StockMovementType";
import "./StockMovementTypeCards.css";

const StockMovementTypeCards = ({ value, onChange }) => {
    const { t } = useTranslation();
    const options = [
        {
            value: MovementType.IN,
            title: t('in'),
            description: t('restock_in_description'),
            hint: t('restock_in_hint'),
            icon: 'fa-solid fa-arrow-down',
            variant: 'success'
        },
        {
            value: MovementType.OUT,
            title: t('out'),
            description: t('restock_out_description'),
            hint: t('restock_out_hint'),
            icon: 'fa-solid fa-arrow-up',
            variant: 'danger'
        },
        {
            value: MovementType.ADJUSTMENT,
            title: t('adjustment'),
            description: t('restock_adjustment_description'),
            hint: t('restock_adjustment_hint'),
            icon: 'fa-solid fa-arrows-rotate',
            variant: 'warning'
        }
    ];

    return (
        <Row className="g-3">
            {options.map(option => {
                const selected = value === option.value;

                return (
                    <Col md={4} key={option.value}>
                        <button
                            type="button"
                            className={`stock-movement-option stock-movement-option--${option.variant} ${selected ? 'is-selected' : ''}`}
                            aria-pressed={selected}
                            onClick={() => onChange(option)}
                        >
                            <span className="stock-movement-option__content">
                                <strong>{option.title}</strong>
                                <small>{option.hint}</small>
                            </span>
                            <span className="stock-movement-option__icon" aria-hidden="true">
                                <i className={option.icon}></i>
                            </span>
                        </button>
                    </Col>
                );
            })}
        </Row>
    );
};

export default StockMovementTypeCards;
